import { render, staticRenderFns } from "./TypeToConfirmModal.vue?vue&type=template&id=9e1fb3e6"
import script from "./TypeToConfirmModal.vue?vue&type=script&lang=ts"
export * from "./TypeToConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports